import React from 'react';
import { colorFor } from '../lib/providerColors';

export default function ProviderColorDot({ displayName, size = 10, className = '' }) {
  const { hex, faded } = colorFor(displayName);
  return (
    <span
      className={`inline-block rounded-full align-middle ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: hex,
        opacity: faded ? 0.5 : 1,
        border: faded ? `1px dashed ${hex}` : 'none',
      }}
      title={displayName}
    />
  );
}
